import React from 'react';

const Llama4OpenSource = () => (
  <article className="news-article-body">
    <p className="news-lead">
      Meta released Llama 4 in April 2025 and it landed with serious impact. The Scout
      variant offered a 10-million-token context window - far beyond anything previously
      available in open weights. The Maverick variant matched GPT-4o on major benchmarks.
      And Meta released them both openly, continuing its bet that open-source AI is the
      right long-term strategy. The broader open-source AI wave is, by any measure,
      accelerating.
    </p>

    <h2>Llama 4's key variants</h2>
    <ul>
      <li>
        <strong>Llama 4 Scout:</strong> A 17-billion active parameter mixture-of-experts model
        (109B total). The headline feature: 10 million token context window. Run it on a single
        H100 GPU. Strong on long-document understanding and multi-document reasoning.
      </li>
      <li>
        <strong>Llama 4 Maverick:</strong> 17B active parameters (400B total, 128 experts).
        Matched GPT-4o on key benchmarks including MMLU, HumanEval, and MATH while being
        significantly cheaper to run. Strong vision capabilities alongside text.
      </li>
      <li>
        <strong>Llama 4 Behemoth:</strong> The training teacher model (2 trillion parameters),
        not yet publicly released. Used to train Scout and Maverick via distillation.
      </li>
    </ul>

    <h2>Why Meta keeps releasing openly</h2>
    <p>
      Meta's open-source AI strategy is strategic, not altruistic. By releasing Llama widely,
      Meta:
    </p>
    <ul>
      <li>Builds an ecosystem that makes switching away from Meta's infrastructure harder</li>
      <li>Gets millions of developers improving, fine-tuning, and finding bugs in the model for free</li>
      <li>Counters OpenAI and Anthropic's commercial advantage by commoditising the base model layer</li>
      <li>Establishes Yann LeCun's open AI philosophy as a credible alternative to safety-focused closed development</li>
    </ul>

    <h2>The open-source AI wave around Llama 4</h2>
    <p>
      Llama 4 launched into an ecosystem already transformed by open-source models:
    </p>
    <ul>
      <li><strong>Mistral 3</strong> and Mixtral remain widely used European open models</li>
      <li><strong>Qwen3</strong> from Alibaba is competitive with frontier models on several tasks</li>
      <li><strong>DeepSeek R1</strong> weights remain publicly available and widely used</li>
      <li><strong>Phi-4</strong> from Microsoft showed strong small-model performance</li>
    </ul>
    <p>
      Together, these releases mean that any developer with reasonable compute can run
      models competitive with commercial APIs from 2023 or early 2024 - entirely locally,
      free, with full control.
    </p>

    <h2>The regulatory challenge</h2>
    <p>
      Open-source AI models create a regulatory headache that closed models don't have.
      You can't recall an open-source model. You can't monitor how it's being fine-tuned
      and used. The EU AI Act's provisions for "general purpose AI" create compliance
      obligations for open-source model developers - something Meta, Mistral, and Alibaba
      are each navigating differently.
    </p>

    <div className="news-insight-box">
      <h3>The big lesson</h3>
      <p>
        Open-source AI has shifted from "good enough for hobbyists" to "competitive with
        commercial frontier models." Llama 4 Maverick matching GPT-4o on benchmarks, while
        being freely downloadable, changes the build-vs-buy calculation for enterprise AI.
        The next year will show whether companies act on that - or whether support, reliability,
        and ecosystem tooling keep them paying for commercial APIs despite the cost difference.
      </p>
    </div>
  </article>
);

export default Llama4OpenSource;
